import store from "@/store"
import "@/assets/css/style.less"
import "nprogress/nprogress.css";

import Antd from "ant-design-vue";
import moment from "moment";

import publicIcons from "@/components/_publicIcons";
import publicComponents from "@/components/_publicComponents";

// import {area} from "@/utils/areaData";
import {area} from "@/api/areaApi";
import {getUpload, getAction, getJson, postAction,postJson} from "@/utils/http/service";
import * as util from "@/utils/util"
import {file_service} from "@/api/adminService";

const {publicPath} = require("../../web.config")

const NuoYun = {
    install(app) {
        app.use(Antd);

        const components = Object.assign({}, publicIcons, publicComponents)
        Object.keys(components).forEach(name => {
            app.component(name, components[name]);
        })

        app.config.globalProperties.getUpload = getUpload;
        app.config.globalProperties.getAction = getAction;
        app.config.globalProperties.postAction = postAction;
        app.config.globalProperties.getJson = getJson;
        app.config.globalProperties.postJson = postJson;
        app.config.globalProperties.moment = moment;
        app.config.globalProperties.$ls = util.ls;
        app.config.globalProperties.momentFormat = util.momentFormat;
        app.config.globalProperties.decimal = util.decimal;
        app.config.globalProperties.getFilePath = util.getFilePath;
        app.config.globalProperties.publicPath = publicPath;
        app.config.globalProperties.imgPath = file_service.images;
        app.config.globalProperties.areaObj = area;
        app.config.globalProperties.getPopupContainer = node => {
            if (node) {
                return node.parentNode;
            }
            return document.body;
        }

        const authDirective = (el, binding) => {
            const auth = binding.value.value;
            const authList = store.getters.authList;
            if (auth) {
                const hasAuth = authList.some(record => auth === record);
                if (!hasAuth) {
                    // el.parentNode ? el.parentNode.removeChild(el) : el.remove();
                    el.classList.add("hideHighest");
                } else {
                    el.classList.remove("hideHighest");
                }
            } else {
                throw new Error(`need roles! Like v-auth="{value:'menuCode'}"`);
            }
        }
        app.directive('auth', {
            mounted(el, binding) {
                authDirective(el, binding);
            },
            updated(el, binding) {
                authDirective(el, binding);
            }
        });

        return app;
    }
}
export default NuoYun
